export const endpoints = {
    protocol: "https:",
    backendUrl: "bluetoken.io",
    frontendUrl: "bluetoken.io",
}

export const moneyInput = {
    decimal: ",",
    thousands: ".",
    // prefix: "U$ ",
    precision: 2,
    masked: false
};

export const cryptoInput = {
    decimal: ".",
    thousands: "",
    precision: 8,
    masked: false
}

export const availableLanguages = [
    "en",
    "es",
    // "pt",
]


// WEBPACK FOOTER //
// ./src/configs/global.js